<template>
    <div class="grcform">
        <GrcDB ref="GRCDB"></GrcDB>    
        <GrcDialog ref="Dialog"
            v-on:popupopened="SetPopupRef('Dialog')"
            v-on:popupclosed="SetPopupRef('')"
        ></GrcDialog>

        <div class="grc_fullwidth_lane">
            <img src="../../../public/styles/images/mgm_1920_2024.jpg" class="mgm_img_1920" />
            <img src="../../../public/styles/images/mgm_1200_2024.jpg" class="mgm_img_1200" />
            <img src="../../../public/styles/images/mgm_768_2024.jpg" class="mgm_img_768" />

            <div class="grc_maincont_lane">
                <div class="info_cont">
                    <span v-show="ProgressID==0">Levél elkészítése folyamatban...</span>
                    <span v-show="ProgressID==1" v-html="ActionResult"></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import axios from "axios";
import GrcButton from '../GrcComponents/GrcButton.vue'
import GrcDB from '../GrcComponents/GrcDB.vue'
import GrcDialog from '../GrcComponents/GrcDialog.vue'


export default {
  name: 'frmMGM',
  components: {
      GrcButton,
      GrcDB,
      GrcDialog,
  },
  props: {
  },
  data () {
      return {
            WSPREFIX: "frmMGM",
            ProgressID:0,
            ActionResult:"",
      }
  },
  model: {
  },  
  methods:{

    scrollToTop() { window.scrollTo(0,0); },

    GetTextBookItem(pCompName)
    {
        return grcmain_GetTextBookItem("frmMGM", pCompName);
    },

    SetPopupRef(pRef)
    {
        gPopupControlName = pRef;
    },


    SetLang()
    {
        this.Init();
    },


    async Init()
    {
        var MGMID = "";
        if ((GRCAPP_GetParameters.ALIAS.toLowerCase() == "mgm") && (GRCAPP_GetParameters.MGMID != "") && (GRCAPP_GetParameters.MGMID != undefined))
        {
            MGMID = GRCAPP_GetParameters.MGMID;
            GRCAPP_GetParameters.MGMID = "";
        }

        this.$refs.GRCDB.ShowLoading(false);
        
        var QP = {
            sMGMID:MGMID,
        };
        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX+"_Init", QP).then(res => { Q = res; });

        this.ProgressID = 1;

        if (Q.APPERR[0].ERR != "")
        {
            this.IsEnabled = false;

            this.$refs.GRCDB.HideLoading();
            if (Q.APPERR[0].ERR.startsWith("APPVER_ERROR"))
            {
                this.$emit("handlecommerror", Q.APPERR[0].ERR);
            }
            else
            {            
                this.ShowInfoDialog(Q.APPERR[0].ERR, "200");
            }
            return;
        }

        this.$refs.GRCDB.HideLoading();
        this.ActionResult = Q.RESULT[0].ActionResult;
        
    },


    async ShowInfoDialog(pText, pHeight)
    {
        var DialogResult = "";
        var p = grccomp_dialog_alert_GetDefaults(grcmain_GetTextBookItem("tech", "informacio"), pText);             
        p.height = pHeight;
        p.width = 400;
        p.padding_top = 20;
        if (grccomp_getScreenSize().width < 400) { p.width = 300; }
        await this.$refs.Dialog.ShowDialog(p).then(res => 
        { 
            DialogResult = res; 
        });               
    },



  },

  created()
  {

  },

  mounted()
  {
    this.$emit("setappheaderversion", "none");
    this.$emit("setappfooterversion", "none");
    gForm = this;
    gPopupControlName = "";

    if (gAppInitDone)
    {
      this.SetLang();
    }
  }

}


</script>


<style scoped>

.info_cont
{
    width: 100%;
    box-sizing: border-box;
    color:#fff;
    font-family: "PremiumDefault";
    font-size:16px;
    line-height: 22px;
    font-weight:normal;
    text-align: center;
    padding: 30px 4px;
    color: #323232;
}

.mgm_img_1920
{
    width:100%;
    display:block;
}

.mgm_img_1200
{
    width:100%;
    display:none;
}

.mgm_img_768
{
    width:100%;
    display:none;
}

@media (max-width:1200px)
{
    .mgm_img_1920
    {
        display:none;
    }

    .mgm_img_1200
    {
        display:block;
    }

    .mgm_img_768
    {
        display:none;
    }

}

@media (max-width:768px)
{
    .mgm_img_1920
    {
        display:none;
    }

    .mgm_img_1200
    {
        display:none;
    }

    .mgm_img_768
    {
        display:block;
    }

}

</style>